import { useEffect, useRef } from 'react';
import { Renderer } from 'interactive-shader-format';

const WebGLBackground = ({ zIndex = 1, audioDataRef = null }) => {
  const canvasRef = useRef(null);
  const rendererRef = useRef(null);
  const animationRef = useRef(null);
  const currentShaderRef = useRef(0);
  const shaderChangeTimerRef = useRef(0);
  const startTimeRef = useRef(Date.now());
  
  // Smoothed parameter values for interpolation
  const smoothedParamsRef = useRef({
    // Fractal shader params
    k: 0.3, h: 0.5, j: 0.5, c: 0.632, s: 0.131, e: 0.3, u: 0.17, m: 0.3,
    // SpaceGhost shader params
    mult: 5, width: 22, phase1: 0.8, phase2: 0.05, density: 0.15, morph: 5, hue: 4, tint: 9, rate: -0.9,
    // CloudEleven shader params
    center: [0.0, 0.0], seed: 514229, zoom: 0.5, cloudRate: 0.25, rot: 0.2, cloudHue: 0.0,
    // Volumetric Fog shader params
    thickness: 0.0, twee: 0.0, drie: 1.0, vier: 0.0, vijf: 1.0,
    // Volumetric Explosion shader params
    mouse: [0.0, 0.0]
  });

  // ISF shaders - add more shaders here for cycling
  const isfShaders = [
//     `/*{
//     "CREDIT": "by echophons",
//     "DESCRIPTION": "",
//     "CATEGORIES": [ "generator"
//     ],
//     "INPUTS": [
    
//         {
//             "NAME": "k",
//             "TYPE": "float",
//             "DEFAULT": 0.3,
//             "MIN": 0.001,
//             "MAX": 0.999
//         },
//         {
//             "NAME": "h",
//             "TYPE": "float",
//             "DEFAULT": 0.5,
//             "MIN": 0.0,
//             "MAX": 1.0
//         },
//         {
//             "NAME": "j",
//             "TYPE": "float",
//             "DEFAULT": 0.5,
//             "MIN": 0.0,
//             "MAX": 1.0
//         },
//             {
//             "NAME": "c",
//             "TYPE": "float",
//             "DEFAULT": 0.632,
//             "MIN": 0.001,
//             "MAX":0.999
//         },
//             {
//             "NAME": "s",
//             "TYPE": "float",
//             "DEFAULT": 0.131,
//             "MIN": 0.001,
//             "MAX":0.999
//         },
//             {
//             "NAME": "e",
//             "TYPE": "float",
//             "DEFAULT": 0.3,
//             "MIN": 0.001,
//             "MAX":0.999
//         },
//             {
//             "NAME": "u",
//             "TYPE": "float",
//             "DEFAULT": 0.17,
//             "MIN": 0.001,
//             "MAX":0.999
//         },
//         {
//             "NAME": "m",
//             "TYPE": "float",
//             "DEFAULT": 0.3,
//             "MIN": 0.001,
//             "MAX": 0.999
//         }
//     ]
// }*/

// // edit of http://glslsandbox.com/e#18752.0
// // additional iputs added by Doctor Mojo
// uniform vec2 mouse;

// vec3   iResolution = vec3(RENDERSIZE, 1.0);
// float  iGlobalTime = TIME;

// float gTime = iGlobalTime*0.5;

// void main( void )
// {
//     float f = 1.0;
//     float g = 1.0;
//     vec2 res = iResolution.xy;
//     vec2 mou = mouse.xy;
    
//     //if (mouse.x < 0.5)
//     //{
//     mou.x = sin(gTime * e)*sin(gTime * u) * 1. + sin(gTime * m);
//     mou.y = (1.0-cos(gTime * c))*sin(gTime * s)*1.0+cos(gTime * k);
//     mou = (mou+1.0) * res;
//     //}
//     vec2 z = ((-res+2.0 * gl_FragCoord.xy) / res.y);
//     vec2 p = ((-res+2.0+mou) / res.y) * j;
//     for( int i = 0; i < 24; i++) 
//     {
//         float d = dot(z,z);
//         z = (vec2( z.x, -z.y ) / d) + p * h; 
//         z.x =  1.0-abs(z.x);
//         f = max( f-d, (dot(z-p,z-p) ));
//         g = min( g*d, sin(dot(z+p,z+p))+1.0);
//     }
//     f = abs(-log(f) / 3.5);
//     g = abs(-log(g) / 8.0);
//     gl_FragColor = vec4(min(vec3(g, g*f, f), 1.0),1.0);
// }`,

    // SpaceGhost shader
    `/*{
  "CREDIT": "by mojovideotech",
  "CATEGORIES": [
    "space"
  ],
  "INPUTS": [
    {
      "NAME": "mouse",
      "TYPE": "point2D",
      "MAX": [
        0,
        1
      ],
      "MIN": [
        -1,
        0
      ]
    },
    {
      "NAME": "mult",
      "TYPE": "float",
      "DEFAULT": 5,
      "MIN": 2,
      "MAX": 12
    },
    {
      "NAME": "width",
      "TYPE": "float",
      "DEFAULT": 22,
      "MIN": 20,
      "MAX": 60
    },
    {
      "NAME": "phase1",
      "TYPE": "float",
      "DEFAULT": 0.8,
      "MIN": 0.01,
      "MAX": 0.99
    },
    {
      "NAME": "phase2",
      "TYPE": "float",
      "DEFAULT": 0.05,
      "MIN": -0.5,
      "MAX": 0.5
    },
    {
      "NAME": "density",
      "TYPE": "float",
      "DEFAULT": 0.15,
      "MIN": 0.05,
      "MAX": 0.5
    },
    {
      "NAME": "morph",
      "TYPE": "float",
      "DEFAULT": 5,
      "MIN": 2,
      "MAX": 10
    },
    {
      "NAME": "hue",
      "TYPE": "float",
      "DEFAULT": 4,
      "MIN": 0.5,
      "MAX": 10
    },
    {
      "NAME": "tint",
      "TYPE": "float",
      "DEFAULT": 9,
      "MIN": 0.5,
      "MAX": 10
    },
    {
      "NAME": "rate",
      "TYPE": "float",
      "DEFAULT": -0.9,
      "MIN": -1,
      "MAX": 1
    }
  ],
  "DESCRIPTION": "from http://glslsandbox.com/e#31191.1"
}*/

///////////////////////////////////////////
// SpaceGhost by mojovideotech
//
// mod of glslsandbox.com/e#31191.1
//
// based on :
// SpaceGlowing.glsl     2016-03-02
// original code from shadertoy.com/view/MtX3Ws
// simplified edit: Robert 25.11.2015
// see also shadertoy.com/view/Mlj3zW
//
// Creative Commons Attribution-NonCommercial-ShareAlike 3.0
///////////////////////////////////////////

#ifdef GL_ES
precision mediump float;
#endif

vec3 roty(vec3 p,float a)
{ return mat3(cos(phase1*a),0,-sin(phase2*a), 0,1,1, sin(phase2*a),0,cos(phase1*a)) * p; }

float map(in vec3 p) 
{
    vec3 c=p; float res=0.;
    for (int i=0; i < 4; i++) 
    {
        p= abs(p)/dot(p,p) -.7;
        p.yz= vec2(p.y*p.y-p.z*p.z,2.*p.y*p.z);
        res += exp(-(80.-width) * abs(dot(p,c)));
    }
    return res*0.5;
}

vec3 raymarch(vec3 ro, vec3 rd)
{
    float t=morph;
    vec3 col=vec3(0); float c=0.;
    float n = floor(mult);
    for( int i=0; i < 12; i++ )
    {
        t+= exp(c*-2.0) *density;
        c= map(t *rd +ro);               
        col= vec3(8.*c*c, hue*hue*c*c, c*c*c) *0.16 + col *0.96; //green
        col= vec3(8.*c*c, c*c, tint*tint*c*c) *0.16 + col *0.96; //blue
        col= vec3(8.*c*c/hue, c*c, c*c*c/tint) *0.16 + col *0.96; //red
        n -= 1.0;
        if (n<1.0) { break; 
        }
    }
    return col;
}

void main()
{
    vec2 p= (gl_FragCoord.xy - RENDERSIZE*0.5) / RENDERSIZE.y;
    vec3 ro= roty(vec3(3.), TIME*rate + mouse.x);
    vec3 uu= normalize(cross(ro, vec3(1.0, .0, 0.0)));
    vec3 vv= normalize(cross(uu, ro));
    vec3 rd= normalize(p.x*uu + p.y*vv - ro*0.5 );
    gl_FragColor.rgb= log(raymarch(ro,rd) +1.0) *0.5;
    gl_FragColor.a= 1.0;
}`,
  ];

  useEffect(() => {
    if (!canvasRef.current) return;

    const initISF = async () => {
      try {
        // Get WebGL context
        const gl = canvasRef.current.getContext('webgl') || canvasRef.current.getContext('experimental-webgl');
        if (!gl) {
          console.error('WebGL not supported');
          return;
        }

        // Create ISF renderer
        const renderer = new Renderer(gl);
        rendererRef.current = renderer;

        // Set canvas size
        canvasRef.current.width = window.innerWidth;
        canvasRef.current.height = window.innerHeight;
        gl.viewport(0, 0, window.innerWidth, window.innerHeight);

        // Load first shader
        renderer.loadSource(isfShaders[0]);

        // Animation loop
        const animate = () => {
          const now = Date.now();
          const elapsed = (now - startTimeRef.current) / 1000.0;
          shaderChangeTimerRef.current = elapsed % (isfShaders.length * 45.0); // Change every 45 seconds (slower transitions)

          // Switch shader every 45 seconds
          const newShaderIndex = Math.floor(shaderChangeTimerRef.current / 45.0);
          if (newShaderIndex !== currentShaderRef.current && isfShaders.length > 1) {
            try {
              renderer.loadSource(isfShaders[newShaderIndex]);
              currentShaderRef.current = newShaderIndex;
            } catch (e) {
              console.warn('Error switching to shader', newShaderIndex, ':', e);
              // Skip the problematic shader by trying the next one
              const nextIndex = (newShaderIndex + 1) % isfShaders.length;
              if (nextIndex !== currentShaderRef.current) {
                try {
                  renderer.loadSource(isfShaders[nextIndex]);
                  currentShaderRef.current = nextIndex;
                } catch (e2) {
                  console.warn('Fallback shader also failed:', e2);
                }
              }
            }
          }

          // Set shader parameters - using default values (audio reactivity disabled for now)
          try {
            // const audioData = audioDataRef?.current;
            // Audio reactivity disabled - using default shader parameter values
            if (false) { // Disabled audio reactivity
              // Calculate target parameter values based on current shader
              let targetParams = {};
              
              if (currentShaderRef.current === 0) {
                // Fractal shader - extremely subtle ranges
                targetParams = {
                  k: 0.3 + (audioData.kickLevel || 0) * 0.015,
                  h: 0.5 + (audioData.bassPunchLevel || 0) * 0.02,
                  j: 0.5 + (audioData.clapLevel || 0) * 0.018,
                  c: 0.632 + (audioData.bassLevel || 0) * 0.012,
                  s: 0.131 + ((audioData.kickLevel || 0) + (audioData.clapLevel || 0)) / 2 * 0.01,
                  e: 0.3 + (audioData.bassLevel || 0) * 0.015,
                  u: 0.17 + (audioData.kickLevel || 0) * 0.012,
                  m: 0.3 + (audioData.averageLevel || 0) * 0.018
                };
              } else if (currentShaderRef.current === 1) {
                // SpaceGhost shader - map to different parameters
                targetParams = {
                  mult: 5 + (audioData.kickLevel || 0) * 3,        // 5-8 range
                  width: 22 + (audioData.bassLevel || 0) * 15,     // 22-37 range  
                  phase1: 0.8 + (audioData.clapLevel || 0) * 0.1,  // 0.8-0.9 range
                  phase2: 0.05 + (audioData.highLevelRaw || 0) * 0.2, // 0.05-0.25 range
                  density: 0.15 + (audioData.averageLevel || 0) * 0.1, // 0.15-0.25 range
                  morph: 5 + (audioData.bassPunchLevel || 0) * 2,   // 5-7 range
                  hue: 4 + (audioData.kickLevel || 0) * 2,         // 4-6 range
                  tint: 9 + (audioData.clapLevel || 0) * 0.5,      // 9-9.5 range
                  rate: -0.9 + (audioData.bassLevel || 0) * 0.3    // -0.9 to -0.6 range
                };
              }

              // Smooth interpolation factor
              const smoothing = 0.08;
              
              // Apply exponential moving average for smooth transitions
              const smoothed = smoothedParamsRef.current;
              Object.keys(targetParams).forEach(key => {
                smoothed[key] += (targetParams[key] - smoothed[key]) * smoothing;
              });

              // Set parameters for current shader
              const paramNames = Object.keys(targetParams);
              const debugParams = {};
              paramNames.forEach(name => {
                debugParams[name] = smoothed[name].toFixed(3);
              });

              // Set all available parameters for the current shader
              paramNames.forEach(paramName => {
                if (paramName in renderer.uniforms) {
                  renderer.setValue(paramName, smoothed[paramName]);
                }
              });
            } else {
              // Fallback to time-based animation when no audio data - much slower and more subtle
              if ('k' in renderer.uniforms) {
                renderer.setValue('k', 0.3 + Math.sin(elapsed * 0.08) * 0.03);
              }
              if ('h' in renderer.uniforms) {
                renderer.setValue('h', 0.5 + Math.sin(elapsed * 0.05) * 0.05);
              }
              if ('j' in renderer.uniforms) {
                renderer.setValue('j', 0.5 + Math.cos(elapsed * 0.06) * 0.04);
              }
              if ('c' in renderer.uniforms) {
                renderer.setValue('c', 0.632 + Math.sin(elapsed * 0.04) * 0.025);
              }
              if ('s' in renderer.uniforms) {
                renderer.setValue('s', 0.131 + Math.cos(elapsed * 0.07) * 0.02);
              }
              if ('e' in renderer.uniforms) {
                renderer.setValue('e', 0.3 + Math.sin(elapsed * 0.09) * 0.03);
              }
              if ('u' in renderer.uniforms) {
                renderer.setValue('u', 0.17 + Math.cos(elapsed * 0.11) * 0.025);
              }
              if ('m' in renderer.uniforms) {
                renderer.setValue('m', 0.3 + Math.sin(elapsed * 0.13) * 0.04);
              }
              
              // CloudEleven shader parameters - slow and subtle movements
              if ('center' in renderer.uniforms) {
                renderer.setValue('center', [
                  Math.sin(elapsed * 0.03) * 0.1,
                  Math.cos(elapsed * 0.025) * 0.1
                ]);
              }
              if ('seed' in renderer.uniforms) {
                renderer.setValue('seed', 514229 + Math.sin(elapsed * 0.01) * 50000);
              }
              if ('zoom' in renderer.uniforms) {
                renderer.setValue('zoom', 0.5 + Math.sin(elapsed * 0.06) * 0.1);
              }
              if ('rate' in renderer.uniforms) {
                renderer.setValue('rate', 0.25 + Math.sin(elapsed * 0.04) * 0.1);
              }
              if ('rot' in renderer.uniforms) {
                renderer.setValue('rot', 0.2 + Math.cos(elapsed * 0.08) * 0.05);
              }
              if ('hue' in renderer.uniforms) {
                renderer.setValue('hue', Math.abs(Math.sin(elapsed * 0.02)) * 0.3);
              }
              
              // Volumetric Fog shader parameters - very subtle movements
              if ('thickness' in renderer.uniforms) {
                renderer.setValue('thickness', Math.abs(Math.sin(elapsed * 0.015)) * 0.1);
              }
              if ('twee' in renderer.uniforms) {
                renderer.setValue('twee', Math.sin(elapsed * 0.02) * 0.3);
              }
              if ('drie' in renderer.uniforms) {
                renderer.setValue('drie', 1.0 + Math.sin(elapsed * 0.018) * 2.0);
              }
              if ('vier' in renderer.uniforms) {
                renderer.setValue('vier', Math.abs(Math.cos(elapsed * 0.012)) * 0.2);
              }
              if ('vijf' in renderer.uniforms) {
                renderer.setValue('vijf', 0.75 + Math.sin(elapsed * 0.01) * 0.25);
              }
              
              // Volumetric Explosion shader parameters - subtle mouse movement
              if ('mouse' in renderer.uniforms) {
                renderer.setValue('mouse', [
                  Math.sin(elapsed * 0.02) * 0.1,
                  Math.cos(elapsed * 0.015) * 0.08
                ]);
              }
            }
          } catch (e) {
            console.warn('Error setting shader parameters:', e);
          }

          // Render
          try {
            renderer.draw(canvasRef.current);
          } catch (e) {
            console.warn('Error rendering:', e);
          }

          animationRef.current = requestAnimationFrame(animate);
        };

        // Start animation
        animationRef.current = requestAnimationFrame(animate);

        // Handle resize
        const handleResize = () => {
          if (canvasRef.current && gl) {
            canvasRef.current.width = window.innerWidth;
            canvasRef.current.height = window.innerHeight;
            gl.viewport(0, 0, window.innerWidth, window.innerHeight);
          }
        };

        window.addEventListener('resize', handleResize);

      } catch (e) {
        console.error('Error initializing ISF:', e);
      }
    };

    initISF();

    return () => {
      // Cleanup
      try {
        if (animationRef.current) {
          cancelAnimationFrame(animationRef.current);
          animationRef.current = null;
        }

        if (rendererRef.current) {
          // ISF renderer cleanup if available
          if (rendererRef.current.destroy) {
            rendererRef.current.destroy();
          }
          rendererRef.current = null;
        }

        window.removeEventListener('resize', () => {});
      } catch (e) {
        console.error('Error cleaning up ISF:', e);
      }
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: zIndex,
        pointerEvents: 'none',
        // border: '3px solid lime' // Debug border removed
      }}
    />
  );
};

export default WebGLBackground;